import React from 'react';
/* import {CustomDropDown} from '../../../../manageOrders/components/internalCommons/customDropDown';
import {CURRENCY_LIST} from '../../../constants';
import CurrencyInput from 'react-currency-input-field'; */
import moment from 'moment';
import {dateFormatShow} from '../../../common/constants/datesFormat';

export const columnsColors = (onChangeSelectState) => {
  return [
    {
      'Header': () => <span className='header-title'>Color Exterior</span>,
      'accessor': 'outDoorColor',
    },
    {
      'Header': () => <span className='header-title'>Color Ext. Descripción</span>,
      'accessor': 'outDoorColorDescription',
    },
    {
      'Header': () => <span className='header-title'>Color Interior</span>,
      'accessor': 'inDoorColor',
    },
    {
      'Header': () => <span className='header-title'>Color Int. Descripción</span>,
      'accessor': 'inDoorColorDescription',
    },
    {
      'Header': () => <span className='header-title'>Tipo de Color</span>,
      'accessor': 'colorTypeDescription',
    },
    {
      'Header': () => <span className='header-title'>Estado</span>,
      'accessor': 'status',
      'Cell': ({
        'row': {original},
      }) => {
        return <>
          <select
            onChange={(e) => onChangeSelectState(e, original)}
            className="select-colors-mainteance"
            value={original.status || ''}>
            <option value="A">ACTIVO</option>
            <option value="I">INACTIVO</option>
          </select>
        </>;
      },
    },
    {
      'Header': () => <span className='header-title'>Usuario Edición</span>,
      'accessor': 'updateUser',
      'Cell': ({
        'row': {original},
      }) => {
        return <>{original.updateUser.toUpperCase()}</>;
      },
    },
    {
      'Header': () => <span className='header-title'>Fecha Edición</span>,
      'accessor': 'updateDate',
      'Cell': ({
        'row': {original},
      }) => {
        const item = original;
        return <>{moment(item.updateDate || item.creationDate).format(dateFormatShow)}</>;
      },
    },
    /* {
      'Header': () => <span className='header-title'>Usuario Edición</span>,
      'accessor': 'currency',
      'Cell': ({
        'value': initialValue,
        'row': {index, original},
        'column': {id},
        updateMyData,
      }) => {
        const handleChange = (value) => {
          updateMyData(index, id, value);
        };
        return <CustomDropDown
          className={'prices-custom-input-small'}
          value={initialValue}
          onChange={(e, {value}) => handleChange(value)}
          options={CURRENCY_LIST}
        />;
      },
    },
    {
      'Header': () => <span className='header-title'>FOB</span>,
      'accessor': 'fob',
      'Cell': ({
        'value': initialValue,
        'row': {index, original},
        'column': {id},
        updateMyData,
      }) => {
        const item = original;
        const handleChange = (value) => {
          updateMyData(index, id, value);
        };
        return <div className='ui input input-price'>
          <CurrencyInput
            className={`prices-custom-input-small ${!item.priceId && 'disabled-custom'}`}
            prefix="$ "
            decimalSeparator=","
            groupSeparator="."
            decimalsLimit={2}
            value={initialValue}
            onValueChange={(value, _) => handleChange(value)}
            placeholder='FOB'
          />
        </div>;
      },
    },
    {
      'Header': () => <span className='header-title'>FLETE</span>,
      'accessor': 'shippingCost',
      'Cell': ({
        'value': initialValue,
        'row': {index, original},
        'column': {id},
        updateMyData,
      }) => {
        const item = original;
        const handleChange = (value) => {
          updateMyData(index, id, value);
        };
        return <div className='ui input input-price'>
          <CurrencyInput
            className={`prices-custom-input-small ${!item.priceId && 'disabled-custom'}`}
            prefix="$ "
            decimalSeparator=","
            groupSeparator="."
            decimalsLimit={2}
            value={initialValue}
            onValueChange={(value, _) => handleChange(value)}
            placeholder='FLETE'
          />
        </div>;
      },
    },
    {
      'Header': () => <span className='header-title'>VALOR COLOR</span>,
      'accessor': 'colorValue',
      'Cell': ({
        'value': initialValue,
        'row': {index, original},
        'column': {id},
        updateMyData,
      }) => {
        const item = original;
        const handleChange = (value) => {
          updateMyData(index, id, value);
        };
        return <div className='ui input input-price'>
          <CurrencyInput
            className={`prices-custom-input-small ${!item.priceId && 'disabled-custom'}`}
            prefix="$ "
            decimalSeparator=","
            groupSeparator="."
            decimalsLimit={2}
            value={initialValue}
            onValueChange={(value, _) => handleChange(value)}
            placeholder='VALOR COLOR'
          />
        </div>;
      },
    },
    {
      'Header': () => <span className='header-title'>COMISIÓN</span>,
      'accessor': 'commission',
      'Cell': ({row, column, updateMyData}) => {
        const handleChange = (value) => {
          updateMyData(row.index, column.id, value);
        };
        return <div className='ui input input-price'>
          <CurrencyInput
            className={`prices-custom-input-small ${!row.original?.priceId && 'disabled-custom'}`}
            prefix="$ "
            decimalSeparator=","
            groupSeparator="."
            decimalsLimit={2}
            value={row.original?.commission || 0}
            onValueChange={(value, _) => handleChange(value)}
            placeholder='COMISIÓN'
          />
        </div>;
      },
    },
    {
      'Header': () => <span className='header-title'>C&F</span>,
      'accessor': 'cif',
      'Cell': ({row}) => {
        return <div className='ui input input-price'>
          <CurrencyInput
            className={'prices-custom-input-small disabled-custom'}
            prefix="$ "
            decimalSeparator=","
            groupSeparator="."
            decimalsLimit={2}
            value={row.original?.cif || 0}
            placeholder='C&F'
          />
        </div>;
      },
    },
    {
      'Header': () => <span className='header-title'>FECHA PROD.&nbsp;INICIO</span>,
      'accessor': 'startDate',
      'Cell': ({
        'row': {original},
      }) => {
        const item = original;
        return <>{item.startDate ? moment(item.startDate).format('MM/YYYY') : ''}</>;
      },
    },
    {
      'Header': () => <span className='header-title'>FECHA PROD. FIN</span>,
      'accessor': 'endDate',
      'Cell': ({
        'row': {original},
      }) => {
        const item = original;
        return <>{item.endDate ? moment(item.endDate).format('MM/YYYY') : ''}</>;
      },
    }, */
  ];
};
